import React from 'react';
import { getSecondary } from '../../styles/colors';
import { BasicButton } from '../../UI';
import BlockTitle from '../../UI/BlockTitle';
import FormRootLayout from './FormRootLayout';
import ModalTranslate from './ModalTranslate';

const MainPortalConfig = ({
	portal,
	translate,
	updateState
}) => {
	const [localState, setLocalState] = React.useState((portal && portal.config) || {});

	const renderForm = () => (
		<div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
			<BlockTitle
				text={'ATENCIÓN: La prioridad de las traducciones es primero Custom, despues Label (la cual referencia a las traducciones que guardamos en el servidor)'}
				style={{
					fontSize: '1.1rem',
					color: 'red',
				}}
			/>
			<div>
				{/* HOME */}
				<BlockTitle text={'Inicio'} style={{ fontSize: '18px' }} />
				<hr/>
				<div style={{ marginTop: '1em', padding: '0 1em' }}>
					{Object.keys(localState.home).map(key => (
						key !== 'dateFormat' && key !== 'bgImage'
					&& <div key={key} style={{ display: 'flex', gap: '1rem', marginBottom: '1em' }}>
						<div style={{ display: 'flex' }}>
							<ModalTranslate
								translate={translate}
								item={localState.home[key]}
								name={key}
								setLocalState={newData => setLocalState({
									...localState,
									home: {
										...localState.home,
										[key]: {
											...localState.home[key],
											...newData
										}
									}
								})}
							/>
						</div>
						<BlockTitle text={key} style={{ width: '160px' }} />
						<div style={{
							display: 'flex',
							justifyContent: 'space-between',
							width: '100%',
							color: localState.home[key].label && 'red'
						}}>
							{localState.home[key].label ? '*Existe label ' : localState.home[key].text.es}
						</div>
					</div>
					))}
				</div>
				{/* SECTIONS */}
				<BlockTitle text={'Sections'} style={{ fontSize: '18px' }} />
				<hr/>
				<div style={{ marginTop: '1em', padding: '0 1em' }}>
					{Object.keys(localState.sections).map(key => (
						key !== 'dateFormat' && key !== 'bgImage'
					&& <div key={key} style={{ display: 'flex', gap: '1rem', marginBottom: '1em' }}>
						<div style={{ display: 'flex' }}>
							<ModalTranslate
								translate={translate}
								item={localState.sections[key]}
								name={key}
								setLocalState={newData => setLocalState({
									...localState,
									sections: {
										...localState.sections,
										[key]: {
											...localState.sections[key],
											...newData
										}
									}
								})}
							/>
						</div>
						<BlockTitle text={key} style={{ width: '160px' }} />
						<div style={{
							display: 'flex',
							justifyContent: 'space-between',
							width: '100%',
							color: localState.sections[key].label && 'red'
						}}>
							{localState.sections[key].label ? '*Existe label ' : localState.sections[key].text.es}
						</div>
					</div>
					))}
				</div>
				{/* FORMS */}
				<BlockTitle text={'Forms'} style={{ fontSize: '18px' }} />
				<hr/>
				<div style={{ marginTop: '1em', padding: '0 1em' }}>
					{Object.keys(localState.forms).map(key => (
						<div key={key} style={{ display: 'flex', gap: '1rem', marginBottom: '1em' }}>
							<div style={{ display: 'flex' }}>
								<ModalTranslate
									translate={translate}
									item={localState.forms[key]}
									name={key}
									setLocalState={newData => setLocalState({
										...localState,
										forms: {
											...localState.forms,
											[key]: {
												...localState.forms[key],
												...newData
											}
										}
									})}
								/>
							</div>
							<BlockTitle text={key} style={{ width: '160px' }} />
							<div style={{
								display: 'flex',
								justifyContent: 'space-between',
								width: '100%',
								color: localState.forms[key].label && 'red'
							}}>
								{localState.forms[key].label ? '*Existe label ' : localState.forms[key].text.es}
							</div>
						</div>
					))}
				</div>
				{/* POPUPS */}
				<BlockTitle text={'Popups'} style={{ fontSize: '18px' }} />
				<hr/>
				<div style={{ marginTop: '1em', padding: '0 1em' }}>
					{Object.keys(localState.popUps).map(key => (
						Object.keys(localState.popUps[key]).map(keyItem => (
							<div key={keyItem} style={{ display: 'flex', gap: '1rem', marginBottom: '1em' }}>
								<div style={{ display: 'flex' }}>
									<ModalTranslate
										translate={translate}
										item={localState.popUps[key][keyItem]}
										name={keyItem}
										setLocalState={newData => setLocalState({
											...localState,
											popUps: {
												...localState.popUps,
												[key]: {
													...localState.popUps[key],
													[keyItem]: {
														...localState.popUps[key][keyItem],
														...newData
													}
												}
											}
										})}
									/>
								</div>
								<BlockTitle text={keyItem} style={{ width: '160px' }} />
								<div style={{
									display: 'flex',
									justifyContent: 'space-between',
									width: '100%',
									color: localState.popUps[key][keyItem].label && 'red'
								}}>
									{localState.popUps[key][keyItem].label ? '*Existe label ' : localState.popUps[key][keyItem].text.es}
								</div>
							</div>
						))
					))
					}
				</div>
				{/* FOOTER */}
				<BlockTitle text={'Footer'} style={{ fontSize: '18px' }} />
				<hr/>
				<div style={{ marginTop: '1em', padding: '0 1em' }}>
					{Object.keys(localState.footer).map(key => (
						key !== 'isActive' && key !== 'links' &&
						<div key={key} style={{ display: 'flex', gap: '1rem', marginBottom: '1em' }}>
							<div style={{ display: 'flex' }}>
								<ModalTranslate
									translate={translate}
									item={localState.footer[key]}
									name={key}
									setLocalState={newData => setLocalState({
										...localState,
										footer: {
											...localState.footer,
											[key]: {
												...localState[key],
												...newData
											}
										}
									})}
								/>
							</div>
							<BlockTitle text={key} style={{ width: '160px' }} />
							<div style={{
								display: 'flex',
								justifyContent: 'space-between',
								width: '100%',
								color: localState.footer[key].label && 'red'
							}}>
								{localState.footer[key].label ? '*Existe label ' : localState.footer[key].text.es}
							</div>
						</div>
					))}
					{Object.keys(localState.footer.links).map(key => (
						<div key={key} style={{ display: 'flex', gap: '1rem', marginBottom: '1em' }}>
							<div style={{ display: 'flex' }}>
								<ModalTranslate
									translate={translate}
									item={localState.footer.links[key]}
									name={key}
									setLocalState={newData => setLocalState({
										...localState,
										footer: {
											...localState.footer,
											links: {
												...localState.footer.links,
												[key]: {
													...localState.footer.links[key],
													...newData
												}
											}
										}
									})}
								/>
							</div>
							<BlockTitle text={key} style={{ width: '160px' }} />
							<div style={{
								display: 'flex',
								justifyContent: 'space-between',
								width: '100%',
								color: localState.footer.links[key].label && 'red'
							}}>
								{localState.footer.links[key].label ? '*Existe label ' : localState.footer.links[key].text.es}
							</div>
						</div>
					))}
				</div>
			</div>
		</div >
	);

	return (
		<FormRootLayout
			form={renderForm()}
			button={
				<BasicButton
					color='white'
					text={translate.save}
					onClick={() => {
						updateState({
							...localState,
							home: {
								...localState.home
							},
						});
					}}
					backgroundColor={{
						backgroundColor: getSecondary(),
						border: `1px solid ${getSecondary()}`,
						boxShadow: 'none',
						color: 'white',
						fontWeight: 'bold'
					}}
				/>
			}
		/>
	);
};


export default MainPortalConfig;

